import React, { useEffect } from "react";
import "./tourhome.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";

const Tourhome = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="tourhome">
      <Banner page="tours" />
    </section>
  );
};

export default Tourhome;
